
import React from 'react';
import { Flex, Stack, useColorModeValue } from '@chakra-ui/react';
import AdminHeader from './AdminHeader';
import AdminNav from './AdminNav';

const MainLayout = ({ children }) => {
    const bgColor = useColorModeValue('gray.50', 'gray.800');
    //const bgColorDark = useColorModeValue('gray.50', 'gray.700');

    return (
        <Flex 
            direction="column" 
            minH="100vh" 
            bg={bgColor}>
            <AdminHeader />
            <Flex flex="1">
                <AdminNav />
                <Stack
                    w={'full'}
                    spacing={4}
                    flex="1"
                    bg={bgColor}
                    p={4}
                    overflow="hidden"
                    >
                    {children}
                </Stack>
            </Flex>
        </Flex>
    );
};

export default MainLayout;
